import { QuestService } from '../services/questService';
import type { StatField } from '../config/lifetimeStats';
import { saveStorage } from './saveStorage';
import { playerSalt } from './hubShared';

/** The quests over the live save (sandboxed under ?debug like everything else). */
export function quests(): QuestService {
  return new QuestService(saveStorage(), playerSalt());
}

/**
 * Count one gameplay event toward the quests. Never throws — a storage fault
 * must not stop play. Call it BEFORE any coin award in the same block, so a
 * period that just rolled over takes its baseline first.
 */
export function recordStat(field: StatField, n = 1): void {
  try {
    quests().record(field, n, Date.now());
  } catch (err) {
    console.warn('[quests] record failed', err);
  }
}
